export const REPORT_OPTIONS = [
  {
    id: 1,
    label: "Diagnostic Report",
    value: 1,
    selected: false,
    disabled: false,
  },
  {
    id: 2,
    label: "Discharge Summary",
    value: 2,
    selected: false,
    disabled: false,
  },
  {
    id: 3,
    label: "Health Document Record",
    value: 3,
    selected: false,
    disabled: false,
  },
  {
    id: 4,
    label: "Immunization Record",
    value: 4,
    selected: false,
    disabled: false,
  },
  {
    id: 5,
    label: "OP Consultation",
    value: 5,
    selected: false,
    disabled: false,
  },
  {
    id: 6,
    label: "Prescription",
    value: 6,
    selected: false,
    disabled: false,
  },
  {
    id: 7,
    label: "Wellness Record",
    value: 7,
    selected: false,
    disabled: false,
  },
  { id: 8, label: "Invoice", value: 8, selected: false, disabled: false },
  { id: 9, label: "Other", value: 9, selected: false, disabled: false },
];
